import{Z as o,d as s}from"./p-CUijiJoX.js";const t=o;const i=s;export{t as ZprModal,i as defineCustomElement};
//# sourceMappingURL=zpr-modal.js.map